import { render, staticRenderFns } from "./skin-types-v2.vue?vue&type=template&id=05debe30&scoped=true"
import script from "./skin-types-v2.vue?vue&type=script&lang=js"
export * from "./skin-types-v2.vue?vue&type=script&lang=js"
import style0 from "./skin-types-v2.vue?vue&type=style&index=0&id=05debe30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05debe30",
  null
  
)

export default component.exports